export default class DadosCadastraisValidator {
    constructor() {
    }
   
    IsLogradouro(nomeLogradouro) {
        if (this.ConferirVazioOuNulo(nomeLogradouro)) {         
            throw new Error("label.preencha_logradouro");
        }
    };

    IsTipoLogradouro(tipoLogradouro) {
        if (this.ConferirVazioOuNulo(tipoLogradouro)) {         
            throw new Error("label.preencha_tipo_logradouro");
        }
    };

    IsComplemento(complemento) {
           if (this.ConferirVazioOuNulo(complemento)) {           
            throw new Error("label.preencha_complemento");
        } 
    };
    
    IsNumero(numero) {
           if (this.ConferirVazioOuNulo(numero)) {           
            throw new Error("label.preencha_numero");
        } 
    };

    IsBairro(bairro) {
           if (this.ConferirVazioOuNulo(bairro)) {           
            throw new Error("label.preencha_bairro");
        } 
    }

    IsCep(cep) {
           if (this.ConferirVazioOuNulo(cep)) {           
            throw new Error("label.preencha_cep");	
        } 
    };

    IsEmail(email) {
        if (this.ConferirVazioOuNulo(email)) {           
            throw new Error("label.preencha_email");	
        } else if (!this.validarEmail(email)) {
            throw new Error("msg.valida_email");
        }
    };

    validarEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };

    ConferirVazioOuNulo(val) {
        if (val == null || val == undefined || val == "") {
            return true
        } 
        return false
    };
}